interface Environment {
	fargateRedirectUri: string;
	cloudfrontRedirectUri: string;
	auth0Domain: string;
	demoSvcAudience: string;
	demoSvcScopes: string;
	clientId: string;
}

interface Config {
	LOCAL: Environment;
	SANDBOX: Environment;
	DEV: Environment;
	QA: Environment;
	UAT: Environment;
}

const commonScopes = [
	'create:example_resource_type_1',
	'create:example_resource_type_2',
	'read:example_resource_type_1',
	'read:example_resource_type_2',
	'update:example_resource_type_1',
	'update:example_resource_type_2',
	'delete:example_resource_type_1',
	'delete:example_resource_type_2'
];

const config: Config = {
	LOCAL: {
		auth0Domain: 'dev-id.ritchiebros.com',
		fargateRedirectUri: 'http://localhost:3000',
		cloudfrontRedirectUri: 'http://localhost:3000',
		demoSvcAudience: 'https://api.dev.test-rid.com/demosvc/',
		demoSvcScopes: commonScopes.join(' '),
		clientId: 'Lg73kZqckJV3Ro2ELpAPAhY5lVYKs4Nw'
	},
	SANDBOX: {
		auth0Domain: 'sandbox-id.test-rid.com',
		fargateRedirectUri: 'https://demoapp.sandbox.other-rid.link',
		cloudfrontRedirectUri: 'https://demoapp.sandbox.test-rid.com',
		demoSvcAudience: 'https://api.sandbox.test-rid.com/demosvc/',
		demoSvcScopes: commonScopes.join(' '),
		clientId: 'qNgI2aPHajutfwUdNiuuKpfXGGHo4Mle'
	},
	DEV: {
		auth0Domain: 'dev-id.ritchiebros.com',
		fargateRedirectUri: 'https://demoapp.dev.other-rid.link',
		cloudfrontRedirectUri: 'https://demoapp.dev.test-rid.com',
		demoSvcAudience: 'https://api.dev.test-rid.com/demosvc/',
		demoSvcScopes: commonScopes.join(' '),
		clientId: 'Lg73kZqckJV3Ro2ELpAPAhY5lVYKs4Nw'
	},
	QA: {
		auth0Domain: 'qa-id.ritchiebros.com',
		fargateRedirectUri: 'https://demoapp.qa.other-rid.link',
		cloudfrontRedirectUri: 'https://demoapp.qa.test-rid.com',
		demoSvcAudience: 'https://api.qa.test-rid.com/demosvc/',
		demoSvcScopes: commonScopes.join(' '),
		clientId: '9UgOxr2S3NcPHS0S0bdLlpkAAWHd4tfC'
	},
	UAT: {
		auth0Domain: 'uat-id.ritchiebros.com',
		fargateRedirectUri: 'https://demoapp.uat.other-rid.link',
		cloudfrontRedirectUri: 'https://demoapp.uat.test-rid.com',
		demoSvcAudience: 'https://api.uat.test-rid.com/demosvc/',
		demoSvcScopes: commonScopes.join(' '),
		clientId: 'kvS08AX41tpFErLyio7Nk8ubSYqPW9fX'
	}
	// This app doesn't have a Prod environment
};

function getEnv(): 'LOCAL' | 'SANDBOX' | 'DEV' | 'QA' | 'UAT'{
	let env = process.env.REACT_APP_ENV || '';

	if (env === 'LOCAL') return env;
	if (env === 'SANDBOX') return env;
	if (env === 'DEV') return env;
	if (env === 'QA') return env;
	if (env === 'UAT') return env;

	console.warn('Environment is not equal to LOCAL, SANDBOX, DEV, QA or UAT. Defaulting to LOCAL.');
	return 'LOCAL';
}

function getInstance(): 'FARGATE' | 'CLOUDFRONT' {
	let instance = process.env.REACT_APP_INSTANCE || '';

	if (instance === 'FARGATE') return instance;
	if (instance === 'CLOUDFRONT') return instance;

	console.warn('The Instance is not equal to FARGATE or CLOUDFRONT.  Defaulting to FARGATE.');
	return 'FARGATE'
}

function getRedirectUri(): string {
	const instance = getInstance();
	const { fargateRedirectUri, cloudfrontRedirectUri } = config[getEnv()];

	if (instance === 'CLOUDFRONT') return cloudfrontRedirectUri;

	return fargateRedirectUri;
}

export const ENV = getEnv();

export const {
	auth0Domain,
	demoSvcAudience,
	demoSvcScopes,
	clientId
} = config[ENV];

export const redirectUri = getRedirectUri();